module.exports = __webpack_public_path__ + "img/banner-7.2b57003e.jpg";